import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from 'src/shared/components/ui/sheet';
import StatsPanel from 'src/app/admin/components/stats-panel/StatsPanel';
import { useProjectStatsQuery } from 'src/app/admin/state/api/adminGraphSlice';

type ProjectStatsSheetProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    projectId: string;
    projectName: string;
};

const ProjectStatsSheet = ({ open, onOpenChange, projectId, projectName }: ProjectStatsSheetProps) => {
    // Aggregates are only worth computing once the drawer is actually open.
    const { data: stats, isLoading, isError } = useProjectStatsQuery({ projectId }, { skip: !open });

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent>
                <SheetHeader>
                    <SheetTitle>Project stats</SheetTitle>
                    <SheetDescription>What {projectName} owns today.</SheetDescription>
                </SheetHeader>

                <div className='mt-6'>
                    <StatsPanel
                        title='eDNA'
                        isLoading={isLoading}
                        isError={isError}
                        figures={[{ label: 'Samples', value: stats?.sampleCount ?? 0 }]}
                    />
                </div>
            </SheetContent>
        </Sheet>
    );
};

export default ProjectStatsSheet;
